export const blockIconsNavigationPayments = (
	<span className='material-symbols-outlined'>payments</span>
);
